import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import NotificationSettings from '../components/NotificationSettings';
import './Settings.css';

const Settings: React.FC = () => {
  const { t } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <div className="settings-container">
        <h1>⚙️ {t('nav.settings')}</h1>

        <div className="settings-sections">
          {/* General Settings */}
          <div className="settings-section">
            <h2>{t('settings.general')}</h2>
            <p className="section-description">
              {t('settings.generalDescription')}
            </p>

            {/* Theme Toggle */}
            <div className="setting-item">
              <div className="setting-info">
                <label className="setting-label">
                  {theme === 'light' ? `🌙 ${t('settings.darkMode')}` : `☀️ ${t('settings.lightMode')}`}
                </label>
                <p className="setting-description">
                  {theme === 'light'
                    ? t('settings.darkModeDescription')
                    : t('settings.lightModeDescription')
                  }
                </p>
              </div>
              <button
                className="btn-toggle-theme"
                onClick={toggleTheme}
              >
                {theme === 'light' ? t('settings.enable') : t('settings.disable')}
              </button>
            </div>
          </div>

          {/* Privacy Settings */}
          <div className="settings-section">
            <h2>{t('settings.privacy')}</h2>
            <p className="section-description">
              {t('settings.privacyDescription')}
            </p>

            {/* My Data - RGPD Rights */}
            <div className="setting-item">
              <div className="setting-info">
                <label className="setting-label">
                  📊 {t('settings.myData')}
                </label>
                <p className="setting-description">
                  {t('settings.myDataDescription')}
                </p>
              </div>
              <button
                className="btn-secondary"
                onClick={() => navigate('/my-data')}
              >
                {t('settings.manage')}
              </button>
            </div>

            {/* Privacy Policy */}
            <div className="setting-item">
              <div className="setting-info">
                <label className="setting-label">
                  🔒 {t('settings.privacyPolicy')}
                </label>
                <p className="setting-description">
                  {t('settings.privacyPolicyDescription')}
                </p>
              </div>
              <button
                className="btn-secondary"
                onClick={() => navigate('/privacy-policy')}
              >
                {t('settings.view')}
              </button>
            </div>

            {/* Terms of Service */}
            <div className="setting-item">
              <div className="setting-info">
                <label className="setting-label">
                  📜 {t('settings.terms')}
                </label>
                <p className="setting-description">
                  {t('settings.termsDescription')}
                </p>
              </div>
              <button
                className="btn-secondary"
                onClick={() => navigate('/terms')}
              >
                {t('settings.view')}
              </button>
            </div>

            {/* Legal Mentions */}
            <div className="setting-item">
              <div className="setting-info">
                <label className="setting-label">
                  ⚖️ {t('settings.legal')}
                </label>
                <p className="setting-description">
                  {t('settings.legalDescription')}
                </p>
              </div>
              <button
                className="btn-secondary"
                onClick={() => navigate('/legal')}
              >
                {t('settings.view')}
              </button>
            </div>
          </div>

          {/* Notification Settings */}
          <div className="settings-section" id="notifications-section">
            <h2 title="notifications">{t('settings.notifications')}</h2>
            <p className="section-description">
              {t('settings.notificationsDescription')}
            </p>
            <NotificationSettings />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
